import React from "react";

export default function Income() {
  return <h1>Income goes here</h1>;
}
